enum DonorTypes {
  USER = 'odu',
  ORG = 'odo',
}

export default DonorTypes;
